module.exports = __webpack_public_path__ + "img/pic-slider-1.7fc2f01.webp";